module.exports = __webpack_public_path__ + "static/img/homeprd3.f91ff08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/homeprd3.png
// module id = 9IMC
// module chunks = 8